import { ASTCall } from '../ast';
import { Context, Func, SqlExpression } from '../types';
import { ExprType } from '../expr_types';
import {
  assertArgShape,
  typecheckExpression,
  TypecheckWarning,
} from '../typecheck';
import { exprToSql } from '../sql';
import { BadInputError } from '@watershed/errors/BadInputError';

// Function to "normalize" a string in the style of pipeline v2.

export const normalize_string_pv2: Func = {
  typecheck(
    ctx: Context,
    call: ASTCall,
    warnings?: Array<TypecheckWarning>
  ): ExprType {
    assertArgShape(call, 1, 2);

    const argType = typecheckExpression(ctx, call.args[0], warnings);

    if (argType.ty !== 'string') {
      throw new BadInputError('normalize string should be used on string type');
    }

    return { ty: 'string' };
  },

  eval(ctx: Context, call: ASTCall) {
    // not sure why I would ...
    throw new Error('Not implemented');
  },

  toSql(ctx: Context, call: ASTCall): SqlExpression {
    const stringSql = exprToSql(ctx, call.args[0]);

    // exact PV2 bigquery normalization
    // lower(REGEXP_REPLACE(emissions_subspecifier, '[^a-zA-Z0-9_*]', '', 'g'));

    const sql = `LOWER(REGEXP_REPLACE(${stringSql.expr}, '[^a-zA-Z0-9_*]', '', 'g'))`;
    return {
      expr: sql,
      stage: stringSql.stage,
      unitExpr: null,
      error: stringSql.error,
      trace: null,
    };
  },
};
